import React from "react";
import Agent from "./agent.jsx";
export const isAuthenticated = () => {
  const token = localStorage.getItem("authToken");
  return token ? true : false;
};

// Function to log in the user (e.g., call an API and store the token)
export const loginUser = async (account, barbershopName) => {
  // Your API call to authenticate the user
  const { requests } = Agent();
  return await requests.publicPost("/auth/login", account, barbershopName);
  // If successful, save the token to localStorage
};
export const registerUser = async (email, barbershopName) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.publicPost("/auth/register", email, barbershopName);
};
export const forgetPassword = async (email, barbershopName) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.publicPost(
    "/auth/forgot-password",
    email,
    barbershopName
  );
};
export const resetPassword = async (
  email,
  password,
  token,
  shopId,
  barbershopName
) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const params = {
    ShopId: shopId,
    Token: token,
    Email: email,
    NewPassword: password,
    ConfirmPassword: password,
  };
  return await requests.publicPost(
    "/auth/reset-password",
    params,
    barbershopName
  );
};
